import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/MiniBlock.module.scss'

import { Container } from 'react-bootstrap'

import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class TakzeMiniBlock extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  render() {

    const { text, btn, text2, grid } = this.props,
    { show_feedback } = this.state

    return (
      <section className={`${styles.section}`}>
        <Container>
          <div className={`${styles.content2} ${styles[grid]}`}>
            <div>
              <div>
                {text}
              </div>
              <GreenButton
                text={btn}
                width={197}
                className={styles.btn}
                action={() => this.showFeedback()}
              />
            </div>
            <div>
              <div className={styles.content2_rb}>
                <div>
                  <div>{text2}</div>
                  <div>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.12685 2.19291C5.89905 1.62343 5.34749 1.25 4.73413 1.25H2.67105C1.88623 1.25 1.25 1.88607 1.25 2.6709C1.25 9.34192 6.65808 14.75 13.3291 14.75C14.1139 14.75 14.75 14.1137 14.75 13.3289L14.7503 11.2655C14.7503 10.6521 14.377 10.1006 13.8075 9.87285L11.8302 9.0822C11.3186 8.87758 10.7362 8.96967 10.313 9.32239L9.80264 9.74801C9.20665 10.2447 8.32972 10.2052 7.78115 9.65659L6.34417 8.21829C5.79559 7.66972 5.75505 6.7935 6.25171 6.19751L6.67725 5.68722C7.02996 5.26397 7.12287 4.68137 6.91825 4.16982L6.12685 2.19291Z" stroke="#3E4C5A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div>8 (831) 423-29-93</div>
                  </div>
                </div>
                <div>
                  <div className={styles.content2_rb_smalltext}>Звоните по номеру</div>
                  <div className={styles.content2_rb_sep} />
                  <div className={styles.content2_rb_smalltext}>Бесплатный звонок</div>
                </div>
              </div>
            </div>
          </div>
        </Container>
        <FeedbackForm
          title={btn}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

TakzeMiniBlock.propTypes = {
  text: PropTypes.string,
  btn: PropTypes.string,
  text2: PropTypes.string,
  grid: PropTypes.string
}

TakzeMiniBlock.defaultProps = {
  text: `Не хватает фото? Мы пришлем Вам больше работ До/После`,
  btn: `Запросить фото`,
  text2: `Хотите быть в числе наших довольных клиентов?`,
  grid: `grid1`
}

export default TakzeMiniBlock